import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { ForAllService } from "../for-all.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import {TranslateService} from '@ngx-translate/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import * as $ from 'jquery';
import Swal from 'sweetalert2';

@Component({
  selector: 'practicas',
  templateUrl: './practicas.component.html',
  styleUrls: ['./practicas.component.scss'],
  animations   : fuseAnimations
})
export class PracticasComponent implements OnInit {

  comunicacionPracticas: any;
  @Input() statusPaso: Observable<any>;
  @Output() actualizaTraducciones: EventEmitter<any> = new EventEmitter();
  @Output() numeroPracticasRequeridas: EventEmitter<any> = new EventEmitter();

  cargando = true;
  guardando: boolean;
  pasoCompleto: boolean;

  displayedColumns = ['practice', 'description', 'statement1', 'statement2'];

  numeroPracticas: number;
  statement1: string;
  statement2: string;
  statement1Part1: string;
  statement1Part2: string;
  statement2Part1: string;
  statement2Part2: string;
  nombreEmpresa: string;

  dataSource: any[];
  dataSourceOriginal: any[];

  formGroupForAll: FormGroup;

  instituto: string;

  constructor(
    private forallService: ForAllService,
    private wizardService: WizardService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
  ) {
    this.getParams();
  }

  ngOnInit() {
    this.comunicacionPracticas = this.statusPaso.subscribe( (datos) => {
      if(datos != null){
        console.log("se envio datos desde componente base: ",datos);
        this.pasoCompleto = datos;
        if(this.pasoCompleto){
          this.bloqueaPracticas();
        }
      }
    });
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; break;
      case '15': case 'ES': this.instituto = 'ES'; break;
    }
  }

  getParams(){
    let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};
    this.forallService.getParams(data).subscribe((respuesta: any) => {
      console.log("getParams:",respuesta);

      this.numeroPracticas = respuesta.objeto.numPracticas;
      this.statement1 = respuesta.objeto.statement1Nativo;
      this.statement2 = respuesta.objeto.statement2Nativo;
      this.nombreEmpresa = respuesta.empresa;
      this.statement1Part1 = this.statement1.split("$replace1")[0];
      this.statement1Part2 = this.statement1.split("$replace1")[1];
      this.statement2Part1 = this.statement2.split("$replace1")[0];
      this.statement2Part2 = this.statement2.split("$replace1")[1].replace("$replace2","");
      // var splitted1 = respuesta['objeto']['statement1Nativo'].split("$replace1");
      // var splitted2 = respuesta['objeto']['statement2Nativo'].split("$replace1");
      // this.statement1Part1 = splitted1[0];
      // this.statement1Part2 = splitted1[1];
      // this.statement2Part1 = splitted2[0];
      // this.statement2Part2 = splitted2[1].replace("$replace2","");
      // localStorage.setItem('numPracticas',''+this.numeroPracticas);
      this.numeroPracticasRequeridas.emit(respuesta.objeto.numPracticas);
      this.getPracticas();
    }, error => {
      console.log("error", error);
    });
  }

  getPracticas(){
    let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};

    this.forallService.getPracticas(data).subscribe((respuesta:any) => {
      console.log("getPracticas:",respuesta);
      this.dataSource = [];
      this.actualizaTraducciones.emit(true);
      if(respuesta.message == 201){

        for (let i = 0; i < this.numeroPracticas; i++) {
          this.dataSource.push(
            {
              position: i,
              practice: '',
              description: '',
              statement1: '',
              statement2: '',
              statement1Part1: this.statement1Part1,
              statement1Part2: this.statement1Part2,
              statement2Part1: this.statement2Part1,
              statement2Part2: this.statement2Part2
            }
          );
        }
      }
      else{
        respuesta.practicas.forEach(practica => {
          this.dataSource.push(
            {
              position: practica.orden,
              practice: practica.practicaForall,
              description: practica.descripcionForall,
              statement1: practica.statement1,
              statement2: practica.statement2,
              statement1Part1: this.statement1Part1,
              statement1Part2: this.statement1Part2,
              statement2Part1: this.statement2Part1,
              statement2Part2: this.statement2Part2
            }
          );
        });

        if(this.numeroPracticas > respuesta.practicas.length){

          let total = respuesta.practicas.length;
          let faltantes = (this.numeroPracticas - total);

          for (let i = 0; i < faltantes; i++) {
            this.dataSource.push(
              {
                position: total,
                practice: '',
                description: '',
                statement1: '',
                statement2: '',
                statement1Part1: this.statement1Part1,
                statement1Part2: this.statement1Part2,
                statement2Part1: this.statement2Part1,
                statement2Part2: this.statement2Part2
              }
            );
            total++;
          }
        }
      }

      this.creaFormGroups();
      this.cargando = false;
      // this.dataSourceOriginal = this.dataSource.slice(0);
      this.dataSourceOriginal = JSON.parse(JSON.stringify(this.dataSource));    //forma medio chambona de clonar arrays, pero jaló alv
      console.log("dataSourceFinal:",this.dataSource);
    }, error => {
      console.log("error", error);
    });
  }

  creaFormGroups(){
    let group = {};
    let iterador = 0;
    this.dataSource.forEach( (practica) => {
      group["practica"+iterador] = new FormControl({ value: practica.practice, disabled: this.pasoCompleto });
      group["descrip"+iterador] = new FormControl({ value: practica.description, disabled: this.pasoCompleto });
      iterador++;
    });
    this.formGroupForAll = new FormGroup(group);
    console.log("formGroupForAll:",this.formGroupForAll);

    this.formGroupForAll.valueChanges.subscribe( (res) => {
      if(this.formGroupForAll.status == 'VALID'){
        // this.formValido.emit(true);
        console.log('formulario completo');
      }
      else{
        // this.formValido.emit(false);
        console.log('formulario incompleto');
      }
    }
    );
  }

  bloqueaPracticas(){
    for(let k in this.formGroupForAll.controls){
      this.formGroupForAll.controls[k].disable();
    }
  }

  actualizaStatement(event:any, posicion:number){
    if(event.target.value.length >= 1){
      this.dataSource[posicion].statement1 = this.statement1.replace('$replace1',event.target.value);
      this.dataSource[posicion].practice = event.target.value;
      this.dataSource[posicion].statement2 = this.statement2.replace('$replace1',event.target.value).replace('$replace2',this.nombreEmpresa);
    }
  }

  guardaPractica(event:any, posicion:number){
    if(!this.guardando){
      if(event.target.value.length >= 1){
        console.log("textoDS:",this.dataSourceOriginal[posicion].practice," textoTaget:",event.target.value);
        if(this.dataSourceOriginal[posicion].practice != event.target.value)
        {
          this.guardando = true;
          $(document).ready(function(){ $(':focus').blur(); });
          this.modalGuardado(1);
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            orden: posicion,
            practicaForall:  event.target.value,
            statement1: this.dataSource[posicion].statement1,
            statement2: this.dataSource[posicion].statement2
          };
          console.log("datosAEnviarPrac:",data);
          this.forallService.guardaDatosPractica(data).subscribe((respuesta:any) => {
            if(respuesta.message == 'Success'){
              this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_PRACTICEREGISTERED'),this.translate.instant('ALERTS.OK'));
              this.actualizaTraducciones.emit(true);
              Swal.close();
              this.dataSourceOriginal[posicion].practice = data.practicaForall;
              this.guardando = false;
            }
          }, error => {
            console.log(error);
          });
        }
        else console.log("es el mismo texto nomms :v");

      }
    }
  }

  guardaDescripcion(event:any, posicion:number){
    if(!this.guardando){
      if(event.target.value.length >= 1){
        console.log("textoDS:",this.dataSourceOriginal[posicion].description," textoTaget:",event.target.value);
        if(this.dataSourceOriginal[posicion].description != event.target.value)
        {
          this.guardando = true;
          $(document).ready(function(){ $(':focus').blur(); });
          this.modalGuardado(2);
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            orden: posicion,
            descripcionForall:  event.target.value
          };
          console.log("datosAEnviarDesc:",data);
          this.forallService.guardaDatosPractica(data).subscribe((respuesta:any) => {
            if(respuesta.message == 'Success'){
              this.openSuccessSnackBar(this.translate.instant('CERTIFICAR.FORALL.MSJ_DESCRIPTIONREGISTERED'),this.translate.instant('ALERTS.OK'));
              this.actualizaTraducciones.emit(true);
              Swal.close();
              this.dataSourceOriginal[posicion].description = data.descripcionForall;
              this.guardando = false;
            }
          }, error => {
            console.log(error);
          });
        }
        else console.log("es el mismo texto nomms :v");
      }
    }
  }

  modalGuardado(opcion:number){
    let mensaje: string;
    switch (opcion) {
      case 1:
        this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });
      break;
      case 2:
        this.translate.get('CERTIFICAR.FORALL.CARGANDO_DESCRIPCION').subscribe((res: string) => { mensaje = res; });
      break;
    }
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

  getestatusform(){
    return this.formGroupForAll.status;
  }

}
